import Button from "./Button";
import { UserConsumer } from "./Context";
import { Navigate } from "react-router-dom";
import Wheel from "./Wheel";
import ProgressBar from "./ProgressBar";

const LoginBox = ({    
  members,
  categoryList,
  wheel,
}) => {
    const isRequredLogin = parseInt(window.themes.user) === 0 && parseInt(window.themes.required_login) === 1;
    if (!isRequredLogin) {
      return <Navigate to="/" />;
    }

    return (
        <div className="CustomLogin__form">
            <div className="CustomLogin__description">
                <p>{window.login_page.description}</p>
                <UserConsumer>
                    {value => (
                    <a
                        className="CustomLogin__button"
                        href={window.themes.login_url}
                    >
                        <Button
                            className="btn-action"
                            iconPosition="start"
                            color="white"
                            background={
                            window.themes?.primary_use_single_color
                                ? window.themes.primary_color
                                : `linear-gradient(${
                                    window.themes?.primary_color_gradient?.direction
                                }, ${
                                    window.themes?.primary_color_gradient?.gradient_colors[0]
                                    ?.color
                                } 0%, ${
                                    window.themes?.primary_color_gradient?.gradient_colors[1]
                                    ?.color
                                } 100%)`
                            }
                            text={window.login_page.button_text}
                        />
                    </a>
                    )}
                </UserConsumer>
            </div>

            <div className="CustomLogin__wheelpreview">           
                
                <Wheel
                members={members}
                data={categoryList}
                {...wheel}
                diameter={500}
                />
                <ProgressBar
                  currentRound="-"
                  totalRound=""
                  isDisplayContent={false}
                />
            </div>
        </div>
  );
};


export default LoginBox;